var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeName == 'index')?_c('Index'):_vm._e(),_vm._v(" "),(_vm.activeName == 'meeting_progress')?_c('Meeting_progress'):_vm._e(),_vm._v(" "),(_vm.activeName == 'meeting_held')?_c('Meeting_held'):_vm._e(),_vm._v(" "),(_vm.activeName == 'setting')?_c('Setting'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6871dd4f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/ma_new_meeting/index.vue
// module id = null
// module chunks = 